/**
 * Shared API Gateway base URL for all backend service calls.
 *
 * The platform's shared gateway path-routes by domain segment:
 *   /v1/core/...                → betty-core-api       (gateway strips /v1/core prefix)
 *   /v1/engagement/...          → betty-engagement      (gateway strips /v1/engagement prefix)
 *   /v1/engagement/admin/...    → betty-engagement      (gateway strips /v1/engagement/admin
 *                                                         → /admin; per-service admin, Epic 12.2)
 *   /v1/integrations/...        → betty-integrations    (gateway strips /v1/integrations prefix)
 *   /v1/integrations/admin/...  → betty-integrations    (gateway strips /v1/integrations/admin
 *                                                         → /admin; per-service admin, Epic 12.3)
 *
 * Per-service admin (Epic 12.2 engagement, Epic 12.3 integrations): admin routes moved
 * from the shared top-level /admin/* to /v1/{service}/admin/*, so every engagement- or
 * integrations-admin caller in this app now uses /v1/{service}/admin/... instead of
 * /admin/....
 *
 * Epic 12.9 (route hygiene): dropped the controller-internal /v1 that
 * escalation-params + tc-documents carried under betty-integrations' admin group
 * (was producing a double-v1 client path,
 * /v1/integrations/admin/v1/escalation-params/*); escalation-params-api.ts now calls
 * the single-v1 /v1/integrations/admin/escalation-params/* path.
 *
 * Survey Builder UI lives in `apps/survey-builder` (pantry). Its betty-catalog APIs
 * remain on /admin/v1/survey-builder/* (not under /v1/engagement/admin).
 *
 * Set VITE_SERVICES_BASE_URL to the gateway origin (no trailing slash).
 * In CI this is resolved from SSM /nrx-platform/${STAGE}/l2-shared/services-domain-name.
 * For local dev, set it in .env.local.
 */
export const SERVICES_BASE_URL: string = (
  (import.meta.env['VITE_SERVICES_BASE_URL'] as string | undefined) ?? ''
).replace(/\/$/, '');
